var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamapigninprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60.7385,
    height: 60.7385,
    rx: 30.3692,
    fill: "#163E6E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3692 11.7114C26.6791 11.7114 23.0718 12.8057 20.0036 14.8558C16.9353 16.9059 14.5439 19.8199 13.1318 23.2291C11.7196 26.6384 11.3501 30.3898 12.0701 34.0091C12.79 37.6283 14.5669 40.9528 17.1763 43.5621C19.7856 46.1714 23.1101 47.9484 26.7293 48.6683C30.3486 49.3882 34.1 49.0187 37.5092 47.6066C40.9185 46.1944 43.8324 43.803 45.8826 40.7348C47.9327 37.6665 49.0269 34.0593 49.0269 30.3691C49.0214 25.4225 47.0539 20.6801 43.5561 17.1823C40.0583 13.6845 35.3159 11.717 30.3692 11.7114ZM30.3692 46.3614C26.1278 46.3614 22.0601 44.6765 19.061 41.6774C16.0618 38.6782 14.3769 34.6105 14.3769 30.3691C14.3769 26.1277 16.0618 22.06 19.061 19.0608C22.0601 16.0617 26.1278 14.3768 30.3692 14.3768V30.3691L41.6721 41.6722C40.1898 43.1597 38.4282 44.3397 36.4885 45.1445C34.5488 45.9492 32.4692 46.3628 30.3692 46.3614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_3980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6462,
    height: 42.6462,
    fill: "white",
    transform: "translate(9.04614 9.0459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamapigninprogress);
export default __webpack_public_path__ + "static/media/camapigninprogress.cc7589213fc20a6f5d02e08663e2a09d.svg";
export { ForwardRef as ReactComponent };